export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAH0lEQVQY02NIKahiQMP/oRhFnGFgFf4nBpOkcLD7GgA9g6ZVR7y56QAAAABJRU5ErkJggg=="